import './image-slider.scss';
import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';

class ImageSlider {
    constructor ($imageSlider) {
        this.$imageSlider = $imageSlider;

        this.$slider = this.$imageSlider.querySelector('[data-image-slider="slider"]');
        this.slider = undefined;
    }

    initialize () {
        if (this.$slider) {
            this.initSlider();
            this.checkActiveImageFormat();
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            a11y: true,
            keyboard: true,
            slidesPerView: 'auto',
            resistanceRatio: 0,
            centeredSlides: true,
            spaceBetween: 24,
            pagination: {
                el: this.$imageSlider.querySelector('[data-image-slider="fraction"]'),
                type: 'fraction'
            },
            navigation: {
                prevEl: this.$imageSlider.querySelector('[data-image-slider="prev"]'),
                nextEl: this.$imageSlider.querySelector('[data-image-slider="next"]')
            },
            breakpointsInverse: true,
            breakpoints: {
                1024: {
                    spaceBetween: 40
                },
                1440: {
                    spaceBetween: 60
                }
            },
            on: {
                transitionStart: () => {
                    this.checkActiveImageFormat();
                }
            }
        });
    }

    checkActiveImageFormat () {
        const $activeSlide = this.$slider.querySelector('.swiper-slide-active');

        if ($activeSlide) {
            if ($activeSlide.classList.contains('image-slider__slide--landscape')) {
                this.$slider.classList.add('image-slider__slider--landscape');
                this.$slider.classList.remove('image-slider__slider--portrait');
            } else if ($activeSlide.classList.contains('image-slider__slide--portrait')) {
                this.$slider.classList.add('image-slider__slider--portrait');
                this.$slider.classList.remove('image-slider__slider--landscape');
            }
        }
    }
}

export { ImageSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-image-slider="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ImageSlider($root);
            $rootAPI.initialize();
        });
    }
});
